import { anniversary25th } from "./namespace/special/anniversary25th/anniversary25th";
import { interview25th } from "./namespace/special/interview25th/interview25th";

if (document.querySelector(".p-25thanniversary")) {
  anniversary25th();
}

if (document.querySelector(".p-25th-interview")) {
  interview25th();
}
